import React from 'react'
import { useCylinder } from '@react-three/cannon'
import { Lathe } from '@react-three/drei';
import { Vector2 } from 'three';

export const InnerRing = ({ ...props }) => {
    const { position = [0, 1.6, 0], rotation, radius = .28, height = 0.1 } = props;
    
    const segmentsCntPhysics = 12;
    const segmentsCntView = 24;
    const thickness = 0.01

    const [ref] = useCylinder(() => ({
        position,
        rotation,
        args: [radius, radius, 1.5 * height, segmentsCntPhysics],
        type: "Static"
    }), null, [position, rotation, radius, segmentsCntPhysics, height]);

    const p = [
        new Vector2(radius, 0),
        new Vector2(radius, .1),
        new Vector2(radius - thickness, .1),
        new Vector2(radius - thickness, 0)
    ]

    return (
        <group ref={ref} >

            <mesh castShadow receiveShadow>
                <cylinderGeometry attach="geometry" args={[radius - .01, radius - .01, 0.03, segmentsCntView]} />
                <meshStandardMaterial attach="material" color={0xd0d0fd} roughness={0.8} />
            </mesh>
            <Lathe castShadow args={[p, 32]} scale={[1, .5, 1]} position={[0, 0, 0]} >
                <meshStandardMaterial attach="material" color={0xf0f0fd} roughness={0.8} />
            </Lathe>
            <Lathe args={[p, 32]} position={[0, height / 2, 0]} >
                <meshPhysicalMaterial
                    clearcoat={0}
                    reflectivity={1}
                    depthWrite={false} color={0xf0f0fd} ior={1.33} transmission={1} roughness={0} />
            </Lathe>
        </group>
    )
}
export default InnerRing;